import { EventAction, EventType } from '../../types/events';
import eventQueue from '../queue';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var data = _a.data, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (data.eventId === 'DDForm-edit') {
            return fireAnalyticsEvent(EventAction.EDIT_INFO, {}, EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT);
        }
        return null;
    });
}
attachEventListeners();
